import { MAX_SYMBOLS_PER_REQUEST_LIMIT } from './constants';

export const chunkSymbols = (symbols: string[]): string[][] => {
  const chunks: string[][] = [];
  for (let i = 0; i < symbols.length; i += MAX_SYMBOLS_PER_REQUEST_LIMIT) {
    chunks.push(symbols.slice(i, i + MAX_SYMBOLS_PER_REQUEST_LIMIT));
  }
  return chunks;
};

